import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/pages/Main'),
      name: 'main',
      redirect: "/home",
      meta: {
        breadcrumb: 'ホーム'
      },
      beforeEnter(to, from, next) {
        if (!localStorage.getItem("token")) {
          next({ path: '/login' });
        } else {
          next();
        }
      },
      children: [
        {
          path: '/home',
          component: () => import('@/pages/auth/template/Home'),
          name: 'home',
          meta: {
            breadcrumb: null
          },
        },
        {
          path: '/templates',
          component: () => import('@/pages/auth/template/Index'),
          name: 'templates',
          meta: {
            breadcrumb: '詳細指定読取'
          },
        },
        {
          path: '/export_xlsx',
          component: () => import('@/pages/auth/template/ExportXlsx'),
          name: 'export_xlsx',
          meta: {
            breadcrumb: '配置再現読取'
          },
        },
        {
          path: '/business_card',
          component: () => import('@/pages/auth/template/BusinessCard'),
          name: 'business_card',
          meta: {
            breadcrumb: '名刺OCR'
          },
        },
        {
          path: '/templates/:id',
          component: () => import('@/pages/auth/template/Edit'),
          name: 'template.edit',
          meta: {
            breadcrumbs: [
              {
                path: '/templates',
                text: '詳細指定読取'
              },
              {
                text: 'テンプレートの編集'
              }
            ]
          },
          props: true,
        },
        {
          path: '/assignment/:id',
          component: () => import('@/pages/auth/template/Assignment'),
          name: 'template.assignment',
          meta: {
            breadcrumb: '正解答'
          },
          props: true,
        },
        {
          path: '/user_profile',
          component: () => import('@/pages/auth/user/Profile'),
          name: 'user_profile',
          meta: {
            breadcrumb: 'ユーザープロファイル'
          },
          children: [
            {
              path: '/user_profile/key',
              component: () => import('@/pages/auth/user/ListKey'),
              name: 'user_list_key',
              meta: {
                breadcrumb: 'ユーザープロファイル'
              },
            }
          ]
        },
        {
          path: '/master_template',
          component: () => import('@/pages/auth/template/master/Index'),
          name: 'master_template',
          meta: {
            breadcrumb: 'テンプレート作成'
          },
        },
        {
          path: '/confirm_result/:template_id([6])/batch/:template_batch_id',
          component: () => import('@/pages/auth/template/BusinessCardResult'),
          name: 'business_card_result',
          props: true,
          meta: {
            breadcrumbs: [
              {
                path: '/business_card',
                text: '名刺OCR'
              },
              {
                text: '結果確認'
              }
            ],
          },
        },
        {
          path: '/confirm_result/:template_id([7])/batch/:template_batch_id',
          component: () => import('@/pages/auth/template/ExportXlsxResult'),
          name: 'export_xlsx_result',
          props: true,
          meta: {
            breadcrumbs: [
              {
                path: '/export_xlsx',
                text: '配置再現読取'
              },
              {
                text: '結果確認'
              }
            ]
          },
        },
        {
          path: '/confirm_result/:template_id/batch/:template_batch_id',
          component: () => import('@/pages/auth/template/ConfirmResult'),
          name: 'confirm_result',
          props: true,
          meta: {
            breadcrumbs: [
              {
                path: '/templates',
                text: '詳細指定読取'
              },
              {
                text: '結果確認'
              }
            ]
          },
        },
        {
          path: '/test-ocr/:id',
          component: () => import('@/pages/auth/template/TestOcr'),
          name: 'test-ocr',
          meta: {
            breadcrumb: '即興'
          },
          props: true,
        },
      ]
    },
    {
      path: '/login',
      component: () => import('@/pages/login/Index'),
      beforeEnter(to, from, next) {
        if (localStorage.getItem("token")) {
          next('/');
        } else {
          next();
        }
      },
      children: [
        {
          path: '/',
          component: () => import('@/pages/login/Login'),
          name: 'login',
        },
        {
          path: '/forgot_password',
          name: 'forgot_password',
          component: () => import('@/pages/login/ForgotPassword'),
        },
        {
          path: "/user/change-password/:token",
          name: "reset_password",
          component: () => {
            return import("@/pages/login/ResetPassword");
          },
        },
        {
          path: '/register',
          name: 'register',
          component: () => import('@/pages/login/Register'),
        },
      ]
    },
    {
      path: '/admin',
      component: () => import('@/pages/Main.vue'),
      redirect: "/admin/user",
      children: [
        {
          path: '/admin/statistical',
          component: () => import('@/pages/admin/user/Statistical'),
          name: 'admin_statistical',
          meta: {
            breadcrumb: '処理の統計'
          },
        },
        {
          path: '/admin/statistical/:id',
          component: () => import('@/pages/admin/user/Statistical'),
          name: 'admin_statistical_organizations',
          meta: {
            breadcrumb: '処理の統計'
          },
        },
        {
          path: '/admin/user',
          component: () => import('@/pages/admin/user/List'),
          name: 'admin_user',
          meta: {
            breadcrumb: 'ユーザー管理'
          },
        },
        {
          path: '/admin/user/:id',
          component: () => import('@/pages/admin/user/List'),
          name: 'admin_user_organizations',
          meta: {
            breadcrumb: 'ユーザー管理'
          },
        },
        {
          path: '/admin/organizations',
          component: () => import('@/pages/admin/organizations/index'),
          name: 'admin_organizations',
          meta: {
            breadcrumb: 'グループ一覧'
          },
        },
        {
          path: '/admin/setting_template',
          component: () => import('@/pages/admin/setting_template'),
          name: 'admin_setting_template',
          meta: {
            breadcrumb: 'Setting Template'
          },
        },
        {
          path: '/admin/organizations/:id/stat',
          component: () => import('@/pages/admin/organizations/stat'),
          name: 'admin_organization_stat',
          meta: {
            breadcrumb: 'Statistic'
          },
        },
      ]
    },
    {
      path: '/404',
      component: () => import('@/pages/Main.vue'),
      children: [
        {
          path: '/',
          name: '404',
          component: () => import('@/pages/errors/404'),
        }
      ]
    },

  ]
});

const originalPush = router.push
router.push = function push(location, onResolve, onReject)
{
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject)
    }

    return originalPush.call(this, location).catch((err) => {
        if (Router.isNavigationFailure(err)) {
            return err
        }

        return Promise.reject(err)
    })
}

export default router;
